import { Injectable } from '@angular/core';
import moment from 'moment';
import { ClipboardService } from 'ngx-clipboard';
import { MessageService } from 'primeng/api';
@Injectable()
export class UtilsService {
  constructor(
    private _clipboardService: ClipboardService,
    private messageService: MessageService,
  ) {}

  removeEmpty(obj: any): any {
    return Object.fromEntries(
      Object.entries(obj)
        .filter(([_, v]) => v != null)
        .map(([k, v]) => [k, v === Object(v) ? this.removeEmpty(v) : v]),
    );
  }

  formatDate(date: string) {
    // return date ? moment.parseZone(date).local().format('DD-MM-yyyy') : '';
    return date ? moment(date).format('DD-MM-yyyy') : '';
  }

  formatHour(date: string) {
    // return date ? moment.parseZone(date).local().format('h:mm:ss a') : '';
    return date ? moment(date).format('h:mm:ss a') : '';
  }

  open(url: string) {
    window.open(url, '_blank');
  }

  copyToClipboard(text: string) {
    if (!text) return;

    this._clipboardService.copy(text);
    this.messageService.add({
      severity: 'success',
      detail: 'Copiado al portapapeles.',
    });
  }

  dateDifference(givenDate: string): string {
    const givenTimestamp = new Date(givenDate).getTime();
    const currentTimestamp = Date.now();
    const timeDifferenceInMilliseconds = currentTimestamp - givenTimestamp;

    const seconds = Math.floor(timeDifferenceInMilliseconds / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (timeDifferenceInMilliseconds < 60000) {
      return `Hace ${seconds} segundos`;
    } else if (timeDifferenceInMilliseconds < 3600000) {
      return `Hace ${minutes} minutos`;
    } else if (timeDifferenceInMilliseconds < 86400000) {
      const remainingMinutes = minutes % 60;
      return `Hace ${hours} horas y ${remainingMinutes} minutos`;
    } else {
      const remainingHours = hours % 24;
      if (remainingHours === 0) {
        return `Hace ${days} días`;
      } else {
        return `Hace ${days} días y ${remainingHours} horas`;
      }
    }
  }

  formatTimeDifference(startDate: string, endDate: string): string {
    const startTime = new Date(startDate).getTime();
    const endTime = new Date(endDate).getTime();

    const differenceInMilliseconds = endTime - startTime;

    const seconds = Math.floor(differenceInMilliseconds / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    let message = '';

    if (days > 0) {
      if (hours % 24 === 0) {
        message = `Procesada en ${days} ${days === 1 ? 'día' : 'días'}`;
      } else {
        message = `Procesada en ${days} ${days === 1 ? 'día' : 'días'} y ${
          hours % 24
        } ${hours % 24 === 1 ? 'hora' : 'horas'}`;
      }
    } else if (hours > 0) {
      const remainingMinutes = minutes % 60;
      if (remainingMinutes > 0) {
        message = `Procesada en ${hours} ${
          hours === 1 ? 'hora' : 'horas'
        } y ${remainingMinutes} ${
          remainingMinutes === 1 ? 'minuto' : 'minutos'
        }`;
      } else {
        message = `Procesada en ${hours} ${hours === 1 ? 'hora' : 'horas'}`;
      }
    } else if (minutes > 0) {
      message = `Procesada en ${minutes} ${
        minutes === 1 ? 'minuto' : 'minutos'
      }`;
    } else if (seconds > 0) {
      message = `Procesada en ${seconds} ${
        seconds === 1 ? 'segundo' : 'segundos'
      }`;
    } else {
      message = 'Procesada en un momento';
    }

    return message;
  }

  isLink(v: string): boolean {
    // return !!v && /^https?:\/\//i.test(v);   // http o https
    return (
      v?.toLowerCase().startsWith('http://') ||
      v?.toLowerCase().startsWith('https://')
    );
  }

  downloadCsv(
    data: any[],
    filename: string = 'data.csv',
    keysToInclude?: string[],
  ): void {
    if (!data || !data.length) {
      return;
    }

    const csvData = this.convertToCsv(data, keysToInclude);
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  private convertToCsv(data: any[], keysToInclude?: string[]): string {
    let csv = '';

    // Create headers
    if (keysToInclude && keysToInclude.length) {
      csv += keysToInclude.join(',') + '\n';
    } else {
      // Use keys from the first object if no specific keys provided
      if (data.length > 0) {
        csv += Object.keys(data[0]).join(',') + '\n';
      }
    }

    // Create rows
    for (let row of data) {
      let csvRow = keysToInclude!.map((key) => {
        let value =
          row[key] === null || row[key] === undefined
            ? ''
            : row[key].toString();
        let escapedValue = value.replace(/"/g, '""'); // escape double quotes
        return `"${escapedValue}"`;
      });
      csv += csvRow.join(',') + '\n';
    }

    return csv;
  }

  getCurrencyKind(currency: any, currencies: any) {
    return currencies.find((el: any) => el.id === currency)?.currency_type.name;
  }

  findService(config: any, currency_name: any, service: string) {
    if (currency_name) {
      const currency = config.currencies.find(
        (curr: any) => curr.id === currency_name,
      );
      return currency?.services.find((el: any) => el.name === service)
        ?.provider_services.length;
    } else return null;
  }
}
